// extracted by mini-css-extract-plugin
export default {"container":"TY-z","topReviewHeading":"UY-z","criticalReview":"VY-z","favorableReview":"WY-z","vsSeparator":"XY-z"};